import React, { useState, useEffect, useContext } from 'react';
import MovieCard from '../components/MovieCard';
import './HomePage.css';
import axios from 'axios';
import UserHistoryContext from '../context/UserHistoryContext';
import { CARD_STEP, getCardsPerScroll } from '../utils/carousel';

function UserHistoryPage() {
  const { watchedIds, likedIds, dislikedIds, loading: historyLoading } = useContext(UserHistoryContext);
  const [watchedMovies, setWatchedMovies] = useState([]);
  const [likedMovies, setLikedMovies] = useState([]);
  const [dislikedMovies, setDislikedMovies] = useState([]);
  const [recommendations, setRecommendations] = useState([]);

  useEffect(() => {
    const fetchMovieDetails = async () => {
      try {
        const [watchedMovieResponses, likedMovieResponses, dislikedMovieResponses] = await Promise.all([
          Promise.all(watchedIds.map(id => axios.get(`/api/movies/${id}`))),
          Promise.all(likedIds.map(id => axios.get(`/api/movies/${id}`))),
          Promise.all(dislikedIds.map(id => axios.get(`/api/movies/${id}`))),
        ]);

        setWatchedMovies(watchedMovieResponses.map(res => res.data));
        setLikedMovies(likedMovieResponses.map(res => res.data));
        setDislikedMovies(dislikedMovieResponses.map(res => res.data));

        fetchRecommendations();
      } catch (error) {
        console.error('Error fetching user history:', error);
      }
    };

    const fetchRecommendations = async () => {
      try {
        const response = await axios.post('/api/movies/recommendations', {
          watched: watchedIds,
          liked: likedIds,
          disliked: dislikedIds,
        });
        setRecommendations(response.data.recommendations);
      } catch (error) {
        console.error('Error fetching recommendations:', error);
      }
    };

    if (!historyLoading) {
      fetchMovieDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [historyLoading]);

  const scrollLeft = (id) => {
    document.getElementById(id).scrollLeft = 0;
  };

  const scrollRight = (id) => {
    document.getElementById(id).scrollLeft += CARD_STEP * getCardsPerScroll();
  };

  return (
    <div className="home-page">
      <div className="genre-section">
        <h1>Watched Movies</h1>
        <div className="movie-grid-wrapper">
          <button className="arrow arrow-left" onClick={() => scrollLeft('watched-movies-grid')}>&lt;</button>
          <div className="movie-grid" id="watched-movies-grid">
            {watchedMovies.map((movie) => (
              <div key={movie.movieid}>
                <MovieCard movie={movie} />
              </div>
            ))}
          </div>
          <button className="arrow arrow-right" onClick={() => scrollRight('watched-movies-grid')}>&gt;</button>
        </div>
      </div>

      <div className="genre-section">
        <h1>Liked Movies</h1>
        <div className="movie-grid-wrapper">
          <button className="arrow arrow-left" onClick={() => scrollLeft('liked-movies-grid')}>&lt;</button>
          <div className="movie-grid" id="liked-movies-grid">
            {likedMovies.map((movie) => (
              <div key={movie.movieid}>
                <MovieCard movie={movie} />
              </div>
            ))}
          </div>
          <button className="arrow arrow-right" onClick={() => scrollRight('liked-movies-grid')}>&gt;</button>
        </div>
      </div>

      <div className="genre-section">
        <h1>Disliked Movies</h1>
        <div className="movie-grid-wrapper">
          <button className="arrow arrow-left" onClick={() => scrollLeft('disliked-movies-grid')}>&lt;</button>
          <div className="movie-grid" id="disliked-movies-grid">
            {dislikedMovies.map((movie) => (
              <div key={movie.movieid}>
                <MovieCard movie={movie} />
              </div>
            ))}
          </div>
          <button className="arrow arrow-right" onClick={() => scrollRight('disliked-movies-grid')}>&gt;</button>
        </div>
      </div>

      <div className="genre-section">
        <h1>Recommendations</h1>
        <div className="movie-grid-wrapper">
          <div className="movie-grid" id="recommendations-grid">
            {Array.isArray(recommendations) && recommendations.map((movie) => (
              <div key={movie.movieid}>
                <MovieCard movie={movie} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserHistoryPage;
